<template>
  <div
    v-show="visible"
    class="mdc-text-field-helper-line"
  >
    <div
      class="mdc-text-field-helper-text"
      :class="styleClasses"
      v-text="text"
    />

    <!-- For a future implementation of the character counter -->
    <!-- <div class="mdc-text-field-character-counter">0 / 10</div> -->
  </div>
</template>

<script>
// https://material.io/develop/web/components/input-controls/text-field/helper-text/
// import { MDCTextFieldHelperText } from '@material/textfield/helper-text'
export default {
  props: {
    helpMessage: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },

  computed: {
    error () {
      return !!this.errorMessage
    },
    help () {
      return !!this.helpMessage
    },
    visible () {
      return this.error || this.help
    },
    text () {
      return this.errorMessage || this.helpMessage
    },
    styleClasses () {
      return {
        'mdc-text-field-helper-text--persistent': this.visible,
        'mdc-text-field-helper-text--validation-msg': this.error
      }
    }
  }

}
</script>

<style lang="scss">
@import "./variables";
@import "@material/textfield/helper-text/mdc-text-field-helper-text";
</style>
